"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

function InputRequiredWarning(_ref) {
  var feedback = _ref.feedback;
  var defaultMsg = 'Autocomplete requires at least 3 characters';
  var msg = feedback ? feedback : defaultMsg;
  return _react.default.createElement("div", null, _react.default.createElement(_antd.Typography.Text, {
    type: "danger"
  }, msg));
}

function LoadingSearch() {
  return _react.default.createElement("div", {
    style: {
      marginTop: '0.2rem'
    }
  }, _react.default.createElement(_antd.Spin, {
    size: "small"
  }), _react.default.createElement(_antd.Typography.Text, {
    style: {
      marginLeft: '0.5rem'
    }
  }, "Searching for matches..."));
}

function SelectedSuccess(_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("div", {
    className: "flex-align-center",
    style: {
      marginTop: '0.2rem'
    }
  }, _react.default.createElement(_antd.Typography.Text, {
    type: "success"
  }, _react.default.createElement(_antd.Icon, {
    type: "check"
  }), children && _react.default.createElement("em", {
    style: {
      marginLeft: '0.5rem'
    }
  }, children)));
}

function NoMatchesFound() {
  return _react.default.createElement("div", {
    className: "no-matches-found-message"
  }, _react.default.createElement(_antd.Typography.Text, null, "No matches found"));
}

var Feedback =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Feedback, _React$Component);

  function Feedback() {
    (0, _classCallCheck2.default)(this, Feedback);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Feedback).apply(this, arguments));
  }

  (0, _createClass2.default)(Feedback, [{
    key: "render",
    value: function render() {
      var inputRequiredFeedback = this.props.inputRequiredFeedback;
      var store = this.props.loadableAutocompleteStore;
      return _react.default.createElement("div", {
        className: "feedback-for-autocomplete-field"
      }, this.shouldShowRequiresInput(store.state) && _react.default.createElement(InputRequiredWarning, {
        feedback: inputRequiredFeedback
      }), this.isSearchingApi(store.state) && _react.default.createElement(LoadingSearch, null), this.shouldShowSelectSuccess(store.state) && this.selectedSuccessMessage(), this.props.hasSubmissionError(store.state) && _react.default.createElement(_antd.Typography.Text, {
        type: "danger"
      }, "Required"), this.noMatchesWereFound(store.state) && _react.default.createElement(NoMatchesFound, null));
    }
  }, {
    key: "shouldShowRequiresInput",
    value: function shouldShowRequiresInput(storeState) {
      var input = storeState.input,
          selectedId = storeState.selectedId;
      return !selectedId && input.length > 0 && input.length < 3;
    }
  }, {
    key: "isSearchingApi",
    value: function isSearchingApi(storeState) {
      var isLoadingOptions = storeState.isLoadingOptions,
          selectedId = storeState.selectedId;
      return isLoadingOptions && !selectedId;
    }
  }, {
    key: "shouldShowSelectSuccess",
    value: function shouldShowSelectSuccess(storeState) {
      var canShowSuccess = this.props.canShowSuccess;
      return storeState.selectedId && canShowSuccess;
    }
  }, {
    key: "noMatchesWereFound",
    value: function noMatchesWereFound(storeState) {
      var input = storeState.input,
          selectedId = storeState.selectedId,
          options = storeState.options,
          isLoadingOptions = storeState.isLoadingOptions;
      var hasIpt = input.length >= this.props.minCharsRequired;
      var noOptions = options.length === 0;
      return hasIpt && noOptions && !isLoadingOptions && !selectedId && storeState.didFetchOptionsOnce;
    }
  }, {
    key: "selectedSuccessMessage",
    value: function selectedSuccessMessage() {
      var name = this.props.optionDisplayNameKey;
      var store = this.props.loadableAutocompleteStore;
      return _react.default.createElement(SelectedSuccess, null, name && store.getSelectedOption && _react.default.createElement("span", null, store.getSelectedOption()[name]));
    }
  }]);
  return Feedback;
}(_react.default.Component);

exports.default = Feedback;
Feedback.propTypes = {
  loadableAutocompleteStore: _propTypes.default.object,
  inputRequiredFeedback: _propTypes.default.string,
  canShowSuccess: _propTypes.default.bool,
  hasSubmissionError: _propTypes.default.func,
  optionDisplayNameKey: _propTypes.default.string.isRequired,
  minCharsRequired: _propTypes.default.number
};